<div *ngIf="isNullOrUndefined(selectedBloc)" class="page">
    <div class="page-padding">
        <div class="page-header-custom secondary">
            <svg-icon class="is-cursor" (click)="window.history.back()" src="assets/svg/arrow.svg"></svg-icon>
            <h1 class="page-title secondary"><span>Check list</span> CFTV</h1>
        </div>
        <div class="row page-container mt-4">
            <div class="col-sm-6 col-md-3 col-xxl-2" *ngFor="let u of checklistResult.blocs">
                <div class="page-card block" (click)="actionSelectBloc(u)">
                    <div class="d-flex align-items-center">
                        <h2 class="block-title">{{ u.name }}</h2>
                        <svg-icon *ngIf="u.done == u.total" src="assets/svg/check-circle.svg"></svg-icon>
                    </div>
                    <div class="d-flex justify-content-between mt-3 is-cursor">
                        <p class="block-text">Total
                            <span>{{ u.done }}</span>
                            <span>/{{ u.total }}</span>
                        </p>
                        <p *ngIf="u.done == u.total" class="block-text">{{ u.lastItemDate | date: 'dd/MM/yyyy' }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="!isNullOrUndefined(selectedBloc, false)" class="page">
    <div class="page-padding">
        <div (click)="actionClearSelectedBloc()" class="page-header-custom secondary is-cursor">
            <svg-icon src="assets/svg/arrow.svg"></svg-icon>
            <h1 class="page-title secondary"><span>Check list  CFTV </span>| {{ selectedBloc.name }}</h1>
        </div>
        <div class="table-responsive">
            <table class="table table_regular">
                <thead>
                <tr>
                    <th scope="col">Código</th>
                    <th scope="col">Local</th>
                    <th class="text-center" scope="col">{{ 'alimentação' | translate }}</th>
                    <th class="text-center" scope="col">{{ 'alinhamento' | translate }}</th>
                    <th class="text-center" scope="col">{{ 'foco' | translate }}</th>
                    <th class="text-center" scope="col">{{ 'sinal' | translate }}</th>
                    <th class="text-center" scope="col">{{ 'tempodegravação' | translate }}</th>
                    <th class="text-center" scope="col">{{ 'comentário' | translate }}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let a of selectedBloc.items">
                    <td>{{ a.camera?.code }}</td>
                    <td>{{ a.camera?.place }}</td>
                    <td>
                        <div class="d-flex justify-content-center" style="gap: 10px">
                            <div class="check-btn" (click)="a.alimentation = 'ok'"
                                 [ngClass]="{'btn-success': a.alimentation === 'ok'}">
                                <svg-icon src="assets/svg/check.svg"></svg-icon>
                            </div>
                            <div (click)="a.alimentation = 'error'" class="check-btn"
                                 [ngClass]="{'btn-danger': a.alimentation === 'error'}">
                                <svg-icon src="assets/svg/close-secondary.svg"></svg-icon>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex justify-content-center" style="gap: 10px">
                            <div class="check-btn" (click)="a.alignment = 'ok'"
                                 [ngClass]="{'btn-success': a.alignment === 'ok'}">
                                <svg-icon src="assets/svg/check.svg"></svg-icon>
                            </div>
                            <div (click)="a.alignment = 'error'" class="check-btn"
                                 [ngClass]="{'btn-danger': a.alignment === 'error'}">
                                <svg-icon src="assets/svg/close-secondary.svg"></svg-icon>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex justify-content-center" style="gap: 10px">
                            <div class="check-btn" (click)="a.focus = 'ok'"
                                 [ngClass]="{'btn-success': a.focus === 'ok'}">
                                <svg-icon src="assets/svg/check.svg"></svg-icon>
                            </div>
                            <div (click)="a.focus = 'error'" class="check-btn"
                                 [ngClass]="{'btn-danger': a.focus === 'error'}">
                                <svg-icon src="assets/svg/close-secondary.svg"></svg-icon>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex justify-content-center" style="gap: 10px">
                            <div class="check-btn" (click)="a.signal = 'ok'"
                                 [ngClass]="{'btn-success': a.signal === 'ok'}">
                                <svg-icon src="assets/svg/check.svg"></svg-icon>
                            </div>
                            <div (click)="a.signal = 'error'" class="check-btn"
                                 [ngClass]="{'btn-danger': a.signal === 'error'}">
                                <svg-icon src="assets/svg/close-secondary.svg"></svg-icon>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="record_td ">
                            <span>{{ a.camera.time }}</span>
                            <div class="input-material input_record  mb-0 ml-2">
                                <input id="name" class="form-control" type="text" required [(ngModel)]="a.daysRecorded"
                                       [maxLength]="15"/>
                                <label for="name">
                                    <span>{{ 'diasdegravação' | translate }}</span>
                                </label>
                            </div>
                        </div>

                    </td>
                    <td class="text-center">
                        <div *ngIf="hasItemNoOk(a)"
                             class="d-flex justify-content-center">
                            <div (click)="actionOpenCommentModal(a)" class="check-btn"
                                 [ngClass]="{'btn-secondary': !isNullOrUndefined(a.comments)}">
                                <svg-icon src="assets/svg/comment.svg"></svg-icon>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <a (click)="actionSave()" class="col-12 btn btn-secondary mt-3">
            {{ 'salvar'|translate }}
        </a>
    </div>
</div>


<app-modal-comment [commentModel]="commentModel" (returnComment)="actionAddComment($event)"></app-modal-comment>
